import { gql } from "@apollo/client"
import { ORDER_LIST_FRAG } from "graphql/order/order.fragments.gql"
import { VENDOR_DETAIL_FRAG } from "./vendor.fragments.gql"

export const VENDOR_LIST = gql`
  query VendorList(
    $query: String
    $departmentId: ID
    $groupName: String
    $status: String
    $first: Int
    $skip: Int
    $filter: UsersByGroupFilterInput
  ) {
    usersByGroup(
      query: $query
      departmentId: $departmentId
      groupName: $groupName
      status: $status
      first: $first
      skip: $skip
      filter: $filter
    ) {
      id
      fullName
      number
      isBlocked
      shopsManaged {
        id
        name
      }
      blockRemark
      status
      statusObj @client {
        id
        name
        intent
      }
      accounts(first: 1, accountType_Codename: "d2f-wallet") {
        id
        balance
        name
        codename
        accountType {
          id
          name
        }
      }
      address {
        id
        village
        address
        district
      }
      groups {
        id
        category {
          id
          codename
        }
        name
      }
      customerId
      createdAt
    }
  }
`

export const VENDOR_DETAIL = gql`
  query VendorDetail($id: Int) {
    userDetails(userId: $id) {
      ...VendorDetailFrag
      creditSet {
        id
        totalAmount
        remainingAmount
        usedAmount
        paymentCycleDays
        startDate
        endDate
        isActive
        status
      }
    }
  }
  ${VENDOR_DETAIL_FRAG}
`

export const VENDOR_MAP_LIST = gql`
  query VendorMapList(
    $query: String
    $departmentId: ID
    $groupName: String
    $status: String
    $first: Int
    $skip: Int
    $filter: UsersByGroupFilterInput
  ) {
    usersByGroup(
      query: $query
      departmentId: $departmentId
      groupName: $groupName
      status: $status
      first: $first
      skip: $skip
      filter: $filter
    ) {
      id
      fullName
      number
      address {
        id
        village
        address
        district
        latitude
        longitude
      }
      status
    }
  }
`

export const VENDORS_SUMMARY = gql`
  query VendorsSummary($latestDays: Int, $filter: SummaryUsersEcomFilterInput) {
    summaryUsersEcom(latestDays: $latestDays, filter: $filter) {
      activeCustomers
      inactiveCustomers
      totalCustomers
      verifiedCustomers
      notVerifiedCustomers
    }
  }
`
export const VENDOR_TRANSACTION_HISTORY = gql`
  query Transactions(
    $filter: TransactionDetailInput
    $skip: Int
    $first: Int
    $query: String
  ) {
    allAccountTransactions(
      first: $first
      skip: $skip
      query: $query
      filter: $filter
    ) {
      id
      date
      account {
        name
        balance
        codename
        id
      }
      status
      amount
      paymentMethod {
        codename
        id
        name
      }
      transactionType {
        id
        name
      }
      referenceId
      remark
      attachments {
        id
        url
      }
    }
  }
`

export const ACCOUNT_STATEMENT = gql`
  query AccountStatement($userId: ID!, $dateFrom: Date, $dateTo: Date) {
    accountStatement(userId: $userId, dateFrom: $dateFrom, dateTo: $dateTo) {
      customer {
        id
        accountNumber
        businessName
        pocName
        mobileNumber
        email
        address
        district
        state
        pincode
        gstin
        isActive
        isBlocked
        vendorTypes
      }
      issuer {
        name
        address
        gstin
        cin
        pan
        number
        email
        website
      }
      dateFrom
      dateTo
      statementDate
      currency
      openingBalance
      totalDebit
      totalCredit
      closingBalance
      creditLimit
      creditUsed
      transactions {
        date
        docNumber
        docType
        invoiceNo
        taxableValue
        gstValue
        withholdingTax
        debitAmount
        creditAmount
        closingBalance
      }
    }
  }
`

export const OUTSTANDING_USER_DETAIL = gql`
  query OutstandingUserDetail(
    $userId: ID!
    $filter: OutstandingOrderDateFilterInput
  ) {
    outstandingUserDetail(userId: $userId, filter: $filter) {
      user {
        id
        firstName
        lastName
        number
        address {
          id
          village
          address
          district
          pincode
        }
        groups {
          id
          category {
            id
            codename
          }
          name
        }
      }
      shops {
        id
        name
        number
        address {
          id
          village
          address
          district
          pincode
        }
      }
      orders {
        ...OrderListFrag
        date
        shop {
          id
          name
        }
      }
      totalOutstandingOrders
      grossOrderValue
      totalOutstandingAmount
    }
  }
  ${ORDER_LIST_FRAG}
`
